export default __webpack_public_path__ + "static/media/react.abf1cf2c.svg";